import { render } from "./MenuBar.vue?vue&type=template&id=8d6702bc&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=8d6702bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6702bc"]])

export default __exports__